import React from 'react';
import { Box, Grid, useDisclosure } from '@chakra-ui/react';
import { Body } from '../Typography';
import useResponsive from 'hooks/useResponsive';
import Link from 'next/link';
import Modal from '../Modal';
import Image from 'next/image';
import { colors } from '@/styles/theme/constants';

const BottomCardInfo = () => {
  const { isMobile } = useResponsive();
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Grid data-testid="card_bottomInfo" alignItems="center" gridColumnGap="8px" gridTemplateColumns="repeat(2, 1fr)" mt={isMobile ? '40px' : '60px'}>
        <Box data-testid="card_bottomInfo_pengaduanPengguna" onClick={onOpen} cursor="pointer" width="100%" height="100%" padding="8px" borderRadius="8px" background="url('/assets/images/bottom_card_info/layanan-pengaduan.svg') no-repeat bottom right, linear-gradient(270deg, #3DA267 -2.43%, #0C7D3B 100.99%)">
          <Body data-testid="card_bottomInfo_pengaduanPengguna_heading" variant="Bold12" color="white" mb="8px">
            <span>Layanan Pengaduan</span><br />
            <span>Konsumen</span>
          </Body>
          <Body data-testid="card_bottomInfo_pengaduanPengguna_moreText" variant="Bold10" color="white">
            Selengkapnya
          </Body>
        </Box>
        <Link href='/my-account/user-guide'>
          <Box data-testid="card_bottomInfo_userGuide" cursor="pointer" width="100%" height="100%" padding="8px" borderRadius="8px" background="url('/assets/images/bottom_card_info/user-guide.svg') no-repeat bottom right, linear-gradient(93deg, #1785FF 2.2%, #24BADC 98.2%)">
            <Body data-testid="card_bottomInfo_userGuide_heading" variant="Bold12" color="white" mb="8px">
              <span>Satu Akun untuk Semua</span><br />
              <span>Ekosistem IDN</span>
            </Body>
            <Body data-testid="card_bottomInfo_userGuide_moreText" variant="Bold10" color="white">
              Selengkapnya
            </Body>
          </Box>
        </Link>
      </Grid>
      <Modal data-testid="modal_pengaduanPengguna" onClose={onClose} isOpen={isOpen} noMaxHeight={true} maxWidth={'375px'} title="Layanan Pengaduan Konsumen">
        <Box mb="24px" data-testid="modal_pengaduanPengguna_idn">
          <Box mb="4px" display="flex">
            <Image data-testid="modal_pengaduanPengguna_idn_logo" src="/assets/images/bottom_card_info/idn-logo.png" width="40px" height="40px" alt="" />
          </Box>
          <Body data-testid="modal_pengaduanPengguna_idn_title" variant="Bold14" mb="4px" color={colors.shade01}>
            IDN (PT Media Putra Nusantara)
          </Body>
          <Body data-testid="modal_pengaduanPengguna_idn_detail" variant="Default14" mb="4px" color={colors.shade04}>
            Jl.Jend Gatot Subroto Kav.27, 3rd Floor, Kuningan, Jakarta (12950)<br/>
            Email: <a href="mailto:support@idn.media">support@idn.media</a> | Telepon: <a href="tel:+622139713888">+62 21 397 13888</a><br/>
          </Body>
        </Box>
        <Box data-testid="modal_pengaduanPengguna_ditjenPktn">
          <Box mb="4px" display="flex">
            <Image data-testid="modal_pengaduanPengguna_ditjenPktn_logo" src="/assets/images/bottom_card_info/ditjen-pktn-logo.png" width="40px" height="40px" alt="" />
          </Box>
          <Body data-testid="modal_pengaduanPengguna_ditjenPktn_title" variant="Bold14" mb="4px" color={colors.shade01}>
            Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga Kementerian Perdagangan
          </Body>
          <Body data-testid="modal_pengaduanPengguna_ditjenPktn_detail" variant="Default14" mb="4px" color={colors.shade04}>
            <a href="tel:085311111010">0853 1111 1010</a> (WhatsApp)
          </Body>
        </Box>
      </Modal>
    </>
  );
}

export default BottomCardInfo;
